// @flow

export const EXECUTION_RESULTS = {
  SKIPPED: "SKIPPED",
  PENDING: "PENDING",
  PASSED: "PASSED",
  FAILED: "FAILED",
  UNKNOWN: "UNKNOWN",
};

export default EXECUTION_RESULTS;
